import React, { useEffect, useState } from "react";
import { getPet } from "@/data/avatarData";

const Eyes = ({ lx, rx, y }) => (
  <g>
    <circle cx={lx} cy={y} r="4" fill="#1E293B" />
    <circle cx={rx} cy={y} r="4" fill="#1E293B" />
    <circle cx={lx + 1.5} cy={y - 1.5} r="1.3" fill="#fff" />
    <circle cx={rx + 1.5} cy={y - 1.5} r="1.3" fill="#fff" />
  </g>
);

const PET_SVGS = {
  dog: (
    <g>
      <ellipse cx="60" cy="86" rx="30" ry="22" fill="#C68642" />
      <path d="M88 84 Q106 70 100 92" stroke="#C68642" strokeWidth="8" fill="none" strokeLinecap="round" />
      <ellipse cx="34" cy="50" rx="10" ry="18" fill="#8B5A2B" />
      <ellipse cx="86" cy="50" rx="10" ry="18" fill="#8B5A2B" />
      <circle cx="60" cy="52" r="26" fill="#C68642" />
      <ellipse cx="60" cy="64" rx="13" ry="10" fill="#F5DEB3" />
      <ellipse cx="60" cy="60" rx="5" ry="4" fill="#1E293B" />
      <path d="M56 68 Q60 74 64 68" stroke="#1E293B" strokeWidth="2" fill="none" />
      <ellipse cx="62" cy="72" rx="4" ry="5" fill="#F472B6" />
      <Eyes lx={50} rx={70} y={48} />
    </g>
  ),
  cat: (
    <g>
      <ellipse cx="60" cy="88" rx="28" ry="20" fill="#94A3B8" />
      <path d="M86 88 Q110 84 100 62" stroke="#94A3B8" strokeWidth="7" fill="none" strokeLinecap="round" />
      <path d="M38 40 L42 14 L58 34 Z" fill="#94A3B8" />
      <path d="M82 40 L78 14 L62 34 Z" fill="#94A3B8" />
      <path d="M42 36 L44 22 L54 34 Z" fill="#F9A8D4" />
      <path d="M78 36 L76 22 L66 34 Z" fill="#F9A8D4" />
      <circle cx="60" cy="52" r="26" fill="#94A3B8" />
      <ellipse cx="50" cy="50" rx="6" ry="7" fill="#22C55E" />
      <ellipse cx="70" cy="50" rx="6" ry="7" fill="#22C55E" />
      <ellipse cx="50" cy="50" rx="2" ry="6" fill="#1E293B" />
      <ellipse cx="70" cy="50" rx="2" ry="6" fill="#1E293B" />
      <path d="M57 62 L63 62 L60 66 Z" fill="#F472B6" />
      <path d="M60 66 Q56 72 52 68 M60 66 Q64 72 68 68" stroke="#1E293B" strokeWidth="2" fill="none" />
      <g stroke="#475569" strokeWidth="1.5">
        <line x1="20" y1="58" x2="44" y2="62" /><line x1="20" y1="68" x2="44" y2="66" />
        <line x1="100" y1="58" x2="76" y2="62" /><line x1="100" y1="68" x2="76" y2="66" />
      </g>
    </g>
  ),
  bunny: (
    <g>
      <ellipse cx="60" cy="90" rx="26" ry="20" fill="#F8FAFC" />
      <ellipse cx="46" cy="22" rx="8" ry="22" fill="#F8FAFC" />
      <ellipse cx="74" cy="22" rx="8" ry="22" fill="#F8FAFC" />
      <ellipse cx="46" cy="24" rx="4" ry="16" fill="#F9A8D4" />
      <ellipse cx="74" cy="24" rx="4" ry="16" fill="#F9A8D4" />
      <circle cx="60" cy="56" r="24" fill="#F8FAFC" />
      <ellipse cx="60" cy="64" rx="5" ry="3.5" fill="#F472B6" />
      <rect x="55" y="68" width="4" height="7" rx="1" fill="#fff" stroke="#CBD5E1" />
      <rect x="61" y="68" width="4" height="7" rx="1" fill="#fff" stroke="#CBD5E1" />
      <Eyes lx={50} rx={70} y={54} />
      <circle cx="40" cy="64" r="5" fill="#FBCFE8" />
      <circle cx="80" cy="64" r="5" fill="#FBCFE8" />
    </g>
  ),
  hamster: (
    <g>
      <ellipse cx="60" cy="70" rx="36" ry="34" fill="#F59E0B" />
      <ellipse cx="60" cy="82" rx="24" ry="20" fill="#FEF3C7" />
      <circle cx="34" cy="40" r="9" fill="#F59E0B" />
      <circle cx="86" cy="40" r="9" fill="#F59E0B" />
      <circle cx="34" cy="40" r="5" fill="#FBCFE8" />
      <circle cx="86" cy="40" r="5" fill="#FBCFE8" />
      <circle cx="36" cy="70" r="9" fill="#FDBA74" />
      <circle cx="84" cy="70" r="9" fill="#FDBA74" />
      <ellipse cx="60" cy="64" rx="4" ry="3" fill="#F472B6" />
      <rect x="57" y="67" width="6" height="6" rx="1" fill="#fff" stroke="#CBD5E1" />
      <Eyes lx={50} rx={70} y={54} />
    </g>
  ),
  parrot: (
    <g>
      <rect x="20" y="104" width="80" height="6" rx="3" fill="#8B5A2B" />
      <ellipse cx="60" cy="74" rx="22" ry="30" fill="#22C55E" />
      <ellipse cx="66" cy="80" rx="12" ry="20" fill="#3B82F6" opacity="0.8" />
      <path d="M40 40 Q34 20 50 26 Q48 14 60 24 Q62 12 70 26" stroke="#EF4444" strokeWidth="5" fill="none" strokeLinecap="round" />
      <circle cx="56" cy="42" r="20" fill="#EF4444" />
      <circle cx="52" cy="40" r="8" fill="#fff" />
      <circle cx="52" cy="40" r="4" fill="#1E293B" />
      <path d="M70 40 Q86 40 82 52 Q76 56 70 50 Z" fill="#FBBF24" />
      <path d="M70 50 Q80 52 76 58 Z" fill="#F59E0B" />
      <path d="M52 104 L52 96 M60 104 L60 96" stroke="#F59E0B" strokeWidth="3" />
    </g>
  ),
  turtle: (
    <g>
      <ellipse cx="60" cy="90" rx="40" ry="10" fill="#4ADE80" />
      <ellipse cx="34" cy="94" rx="8" ry="6" fill="#4ADE80" />
      <ellipse cx="86" cy="94" rx="8" ry="6" fill="#4ADE80" />
      <path d="M22 88 Q60 24 98 88 Z" fill="#15803D" />
      <path d="M40 80 L52 64 L68 64 L80 80 L68 88 L52 88 Z" fill="#22C55E" />
      <path d="M52 64 L60 48 L68 64 M40 80 L28 84 M80 80 L92 84" stroke="#166534" strokeWidth="3" fill="none" />
      <circle cx="98" cy="74" r="13" fill="#4ADE80" />
      <Eyes lx={96} rx={104} y={72} />
      <path d="M96 80 Q100 84 104 80" stroke="#1E293B" strokeWidth="2" fill="none" />
    </g>
  ),
  lioncub: (
    <g>
      <ellipse cx="60" cy="90" rx="30" ry="20" fill="#F5B84A" />
      <path d="M88 90 Q108 82 102 66" stroke="#F5B84A" strokeWidth="7" fill="none" strokeLinecap="round" />
      <circle cx="103" cy="64" r="6" fill="#B45309" />
      <ellipse cx="42" cy="104" rx="9" ry="6" fill="#FCD38A" />
      <ellipse cx="78" cy="104" rx="9" ry="6" fill="#FCD38A" />
      <circle cx="60" cy="52" r="32" fill="#D97706" />
      <g fill="#D97706">
        <circle cx="32" cy="36" r="8" /><circle cx="46" cy="24" r="8" /><circle cx="60" cy="20" r="8" />
        <circle cx="74" cy="24" r="8" /><circle cx="88" cy="36" r="8" /><circle cx="28" cy="56" r="8" /><circle cx="92" cy="56" r="8" />
      </g>
      <circle cx="36" cy="34" r="8" fill="#F5B84A" />
      <circle cx="84" cy="34" r="8" fill="#F5B84A" />
      <circle cx="36" cy="34" r="4" fill="#FBCFE8" />
      <circle cx="84" cy="34" r="4" fill="#FBCFE8" />
      <circle cx="60" cy="54" r="24" fill="#F5B84A" />
      <ellipse cx="60" cy="66" rx="12" ry="9" fill="#FDE7B8" />
      <path d="M55 62 L65 62 L60 67 Z" fill="#7C2D12" />
      <path d="M60 67 Q56 73 51 69 M60 67 Q64 73 69 69" stroke="#7C2D12" strokeWidth="2" fill="none" strokeLinecap="round" />
      <Eyes lx={50} rx={70} y={50} />
      <g stroke="#B45309" strokeWidth="1.5">
        <line x1="34" y1="62" x2="47" y2="65" /><line x1="34" y1="70" x2="47" y2="69" />
        <line x1="86" y1="62" x2="73" y2="65" /><line x1="86" y1="70" x2="73" y2="69" />
      </g>
    </g>
  ),
};

const Mascot = ({ pet, size = 90, cheer = false, name, className = "", testid = "mascot" }) => {
  const p = getPet(pet);
  const [phrase, setPhrase] = useState(p.cheers[0]);

  useEffect(() => {
    if (!cheer) return;
    setPhrase(p.cheers[Math.floor(Math.random() * p.cheers.length)]);
    const t = setInterval(() => setPhrase(p.cheers[Math.floor(Math.random() * p.cheers.length)]), 2800);
    return () => clearInterval(t);
  }, [cheer, p]);

  return (
    <div className={`relative inline-flex flex-col items-center ${className}`} data-testid={testid}>
      {cheer && (
        <div
          className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap bg-white border-2 border-slate-800 rounded-2xl px-2.5 py-1 text-[11px] font-heading font-black text-slate-900 shadow animate-pop-in"
          data-testid="mascot-cheer"
          key={phrase}
        >
          {phrase}
          <span className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-3 h-3 bg-white border-r-2 border-b-2 border-slate-800 rotate-45" />
        </div>
      )}
      <svg viewBox="0 0 120 120" width={size} height={size} className={cheer ? "animate-bounce-slow" : ""} aria-label={`${p.name} mascot`}>
        {PET_SVGS[p.id]}
      </svg>
      {name && (
        <div className="text-[10px] font-black uppercase tracking-wider text-slate-600 -mt-1" data-testid="mascot-name">
          {name}
        </div>
      )}
    </div>
  );
};

export default Mascot;
